
























































import { PropType, defineComponent, computed, ref, getCurrentInstance } from '@vue/composition-api';
import { Message, IntentionData, IntentionBackQuestion, IntentType } from '../../dataType';
import { useLocale } from '../../hooks/useLocale';
import Card from './Card.vue';
import { useMessage } from '../../hooks/useMessage';
import { useIntention } from '../../hooks/useIntention';
import { useVuex } from 'common-module/src/util/useVuex';
export default defineComponent({
  components: {
    Card
  },
  props: {
    message: {
      type: Object as PropType<Message<IntentionData>>,
      required: true
    }
  },
  setup(props) {
    const instance = getCurrentInstance()?.proxy!;
    const { addUserTextMessage, robotWaitWithAsyncOperation, sendMessageAndUpdateId } = useMessage();
    const { intentionTab } = useIntention();
    const { t } = useLocale();
    const vuex = useVuex();
    const isOverseasGuideProjectOwner = computed(
      () => {
        const { roleVoList } = vuex?.state?.overseasGuide?.guideRecommendData;
        return roleVoList?.some((item:any) => item.code === 'PROJECT_MANAGER');
      }
    );
    const activeName = ref<IntentType>(isOverseasGuideProjectOwner.value ? 'risk' : 'work_report');
    if (intentionTab.value.length && !intentionTab.value.some(i => i.value === activeName.value)) {
      activeName.value = intentionTab.value[0].value;
    }
    const options = computed(() => {
      const activeExample = props.message.content.examples.find(item => item.intent === activeName.value)?.value || [];
      return activeExample;
    });
    const clickSendMessage = (value: IntentionBackQuestion, event: Event) => {
      const msg = addUserTextMessage(value.title);
      robotWaitWithAsyncOperation(() => sendMessageAndUpdateId(msg, 'input', value.title, {
        intent: activeName.value,
        event: event,
        parabolaAnimation: true
      }, {
        params: value.params,
        intent: activeName.value
      }));
      instance.$track.send('WebIM_SendIntent', {
        Send_Type: '意图机器人问题',
        Intent_Type: activeName.value,
        Intent_Keywords:  value.title
      }, true);
    };

    return {
      t,
      tabItem: intentionTab,
      activeName,
      options,
      clickSendMessage
    };
  }
});
